import React from "react";
import "./TapOnMenuHeader.scss";
import { MenuLogo } from "../../assets/icons";

export const TapOnMenuHeader = () => (
    <div className="tap-on-menu-header">
        <MenuLogo />
    </div>
);
